<template>
  <div>
    <Menu />
    <ImageModal v-if="route.name != 'login'"></ImageModal>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { publicRoutes } from './router.js';
import Menu from './components/Menu.vue'
import ImageModal from './components/ImageModal.vue';

export default {
  computed: mapState(['route']),
  components: {
      Menu,
      ImageModal
  },
  name: "App",
  created() {},
  data() {
    return {
      publicRoutes
    };
  }
};
</script>
